module.exports = __webpack_public_path__ + "img/balearicislands.f6d88ebd.svg";